export const GET_TAB_REDIRECT = "GET_TAB_REDIRECT";
export const SET_TAB_REDIRECT = "SET_TAB_REDIRECT";
export const GET_HAS_MULTI_DATES = "GET_HAS_MULTI_DATES";
export const SET_HAS_MULTI_DATES = "SET_HAS_MULTI_DATES";
export const GET_START_CHART_DATE = "GET_START_CHART_DATE";
export const SET_START_CHART_DATE = "SET_START_CHART_DATE";
export const GET_END_CHART_DATE = "GET_END_CHART_DATE";
export const SET_END_CHART_DATE = "SET_END_CHART_DATE";
export const SUBMIT_DATA_REQUEST = "SUBMIT_DATA_REQUEST";
export const GET_SUBSCRIBE_KEY = "GET_SUBSCRIBE_KEY";
export const GET_ALT_DATE_RANGE = "GET_ALT_DATE_RANGE";
export const SET_ALT_DATE_RANGE = "SET_ALT_DATE_RANGE";
export const GET_MULTI_DATES = "GET_MULTI_DATES";
export const GET_MULTI_DATES_ONLY = "GET_MULTI_DATES_ONLY";
export const SET_MULTI_DATES = "SET_MULTI_DATES";
export const ADD_MULTI_DATES = "ADD_MULTI_DATES";
export const REMOVE_MULTI_DATES = "REMOVE_MULTI_DATES";
export const MODIFY_MULTI_DATE = "MODIFY_MULTI_DATE";
export const RESTORE_MULTI_DATE = "RESTORE_MULTI_DATE";
export const GET_TAB_TITLE = "GET_TAB_TITLE";
export const SET_TAB_TITLE = "SET_TAB_TITLE";
export const RESET_SENSORS_STATE = "RESET_SENSORS_STATE";
export const GET_INIT_QUERY_DONE = "GET_INIT_QUERY_DONE";
export const SET_INIT_QUERY_DONE = "SET_INIT_QUERY_DONE";
export const SET_GRID_VIEW = "SET_GRID_VIEW";
export const GET_GRID_VIEW = "GET_GRID_VIEW";
